import OutcomesResearchWrapper from "./OutcomesResearchWrapper.vue";
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";
import VueHead from "vue-head";

export default {
  install(Vue, options) {
    Vue.use(VueHead);
    Vue.component("outcomes-research-wrapper", OutcomesResearchWrapper);
    Vue.component("outcomes-footer", Footer);
    Vue.component("outcomes-navbar", Navbar);
  },
};
